import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoaderService } from '../services/loader.service';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
    const loaderService = inject(LoaderService);

    // Skip loader for background/silent requests
    if (req.headers.has('X-Skip-Loader')) {
        return next(req);
    }

    loaderService.show();

    return next(req).pipe(
        finalize(() => loaderService.hide())
    );
};
